/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';

import classNames from 'classnames';
import { EditorsPickActionsProps } from './types';
import { EnumTabTarget } from '$/(cms)/_modules/cmsService/types';
import Button from '$/components/Button';

export const EditorsPickActions = ({
  applyLabel,
  applyUrl,
  buttonTarget,
  onApplyClick,
  onViewDetailsClick,
  showApply,
  showDetails,
  viewDetailsLabel,
}: EditorsPickActionsProps) => {
  if (!showDetails && !showApply) {
    return null;
  }

  return (
    <div
      className={classNames('grid gap-[6px] md:gap-spacing/gap/soft-8px', {
        'grid-cols-1': showDetails !== showApply,
        'grid-cols-2': showDetails && showApply,
      })}
    >
      {showDetails && (
        <Button
          size="small"
          variant="outline"
          styleType="neutral-light-and-blue"
          className="w-full"
          onClick={onViewDetailsClick}
        >
          {viewDetailsLabel}
        </Button>
      )}

      {showApply && (
        <Button
          as="a"
          size="small"
          variant="outline"
          styleType="cta"
          className="w-full"
          href={applyUrl}
          target={buttonTarget === EnumTabTarget.NewTab ? '_blank' : '_self'}
          rel={
            buttonTarget === EnumTabTarget.NewTab
              ? 'noopener noreferrer'
              : undefined
          }
          onClick={onApplyClick}
        >
          {applyLabel}
        </Button>
      )}
    </div>
  );
};
